import React from 'react';
import PropTypes from 'prop-types';
import { FaExclamation as ExclamationMarkIcon } from 'react-icons/fa';
import intersection from 'lodash/intersection';
import classnames from 'classnames';

const ValidationMessagesCellRenderer = ({ data: rowData, value }) => {
  const { validationMessages, touched, forceShowErrors } = rowData ? rowData.meta : {};
  const hasErrors = Object.keys(validationMessages?.errors || {}).length > 0 && (
    forceShowErrors
    || (touched && intersection(Object.keys(validationMessages?.errors), Object.keys(touched)).length > 0)
  );
  const hasWarnings = Object.keys(validationMessages?.warnings || {}).length > 0;
  return (
    <div>
      {hasErrors ? <ExclamationMarkIcon className="text-danger" data-tip={'Row has validation errors'} /> : null}
      {hasWarnings ? <ExclamationMarkIcon className="text-warning" data-tip={'Row has validation warnings'} /> : null}
      {value ? <label className={classnames({ 'text-danger': hasErrors })}>{value}</label> : null}
    </div >
  );
};

const RowMessagesPropTypes = PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string));

ValidationMessagesCellRenderer.propTypes = {
  data: PropTypes.shape({
    meta: PropTypes.shape({
      validationMessages: PropTypes.shape({
        errors: RowMessagesPropTypes,
        warnings: RowMessagesPropTypes,
      }),
      touched: PropTypes.objectOf(PropTypes.bool),
      forceShowErrors: PropTypes.bool,
    }),
  }),
  value: PropTypes.string,
};

export default ValidationMessagesCellRenderer;
